import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import Flow43_2Table from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const Flow43_2 = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("WASTE_PROCESSING") || "Waste processing"}
        subDescription={t("WASTE_PROCESSING_DESC") || "This includes the movement of the removed product or its parts to a facility where they will be sorted, cleaned, shredded, or otherwise prepared for recovery. It models the distance, vehicle type, and emissions involved in reaching a recycling or recovery plant."}
        isNormal={true}
        number={"43.2"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`flow-43-2-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <Flow43_2Table productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default Flow43_2;

